import { render } from "./selectable-button.presentational.vue?vue&type=template&id=b46005d8"
import script from "./selectable-button.presentational.vue?vue&type=script&lang=js"
export * from "./selectable-button.presentational.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__